<app-navbar *ngIf="show"></app-navbar>

<router-outlet></router-outlet>
<app-footer *ngIf="show"></app-footer>
<app-spinner [hidden]="!loading"></app-spinner>

